export default {
  overview: {
    title: "Machines Overview",
    archive_title: "Archived machines",
    subtitle: "List of all machines.",
    actions: {
      create_new: "Create New Machine",
    },
    search: {
      placeholder: "eg. Name",
    },
    table: {
      headers: {
        id: "ID",
        name: "Name",
        unit: "Unit",
        purchasePrice: "Purchase Price",
        createdAt: "Created at",
      },
      empty: {
        purchasePrice: "Not set",
      },
    },
  },
  // Selling unit of a machine for a customer or in a project (LewMachineSellingUnitSelect).
  selling_unit: {
    label: "Selling unit",
    // In the locked select's ⓘ.
    locked:
      "Free to choose with a fixed price. With a surcharge in the purchase's unit, per day also from a week or month.",
    // The unit does not fit the purchase: a surcharge does not convert into it.
    not_converting: "A surcharge does not convert into it: another unit or a fixed price",
    same_as_machine: "Same as machine",
  },
  detail: {
    title: "Machine Details",
    actions: {
      update: "Save",
    },
    tabs: {
      general: "General",
      purchase: "Purchasing",
      files: "File storage",
      activity: "Activity",
    },
    form: {
      name: "Name",
      unit: "Billing unit",
      // In tons; picks the rental supplier's transport class.
      // The own weight for delivery and pick-up, not the load capacity a size like "up to 10 t" often means.
      weight: "Transport weight",
      weight_info: "The machine's own weight, not its load capacity. It picks the supplier's transport class.",
      weight_range: "0 to 1,000 t",
      purchasePrice: "Purchase Price",
      purchaseUnit: "Purchase Price Unit",
      note: "Notes",
      sections: {
        base_data: "Master data",
        purchase: "Purchase",
        note: "Note",
      },
    },
  },
  create: {
    title: "Create Machine",
    subtitle: "Create a new Machine.",
  },
  component: {
    autocomplete: {
      noDataText: "Machine not found {value}",
    },
  },
}
